import styled, { Font, Spacing } from '@nfinite/react-hubstairs/styled'
import ButtonComponent from 'components/Commons/Button'

export const Container = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Title = styled('p')`
  ${Spacing.generateMargin({ top: '0', bottom: 'm' })}
  ${Font.generate({ size: 'm', weight: 'bold' })}
`

export const Message = styled('p')`
  ${Spacing.generateMargin({ vertical: '0' })}
`

export const Button = styled(ButtonComponent)`
  ${Spacing.generateMargin({ top: 'm' })}
`
